export default [
  '#F2473D',
  '#603ECA',
  '#CF007B',
  '#6FB8FC',
  '#ABEB7A',
  '#4070F0',
  '#F1C526',
  '#1AD2AE',
]
